if (typeof process !== 'undefined') {
  if (!process.cwd) {
    process.cwd = () => '/';
  }

  if (!process.memoryUsage) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (process as any).memoryUsage = () => ({
      arrayBuffers: 0,
      external: 0,
      heapTotal: 0,
      heapUsed: 0,
      rss: 0,
    });
  }
}
